import normalize from 'components/Dashboard/utilities/normalizeString';
import integrationsCondition from 'components/Settings/Integrations/integrationsCondition';

export const integrations = [
  {
    name: 'Copilot',
    logo: '20260707-copilot-logo.png',
    color: '#E6F4F5',
    borderColor: '#bad1d0',
  },
  {
    name: 'Claude',
    logo: '20260707-claude-logo.png',
    color: '#FBEEE6',
    borderColor: '#efb595',
  },
  {
    name: 'ChatGPT',
    section: 'chatgpt',
    logo: '20260707-chatgpt-logo.png',
    color: '#E9F6F1',
    borderColor: '#0D8A6A',
  },
  {
    name: 'Gemini',
    logo: '20260707-gemini-logo.png',
    color: '#EAF1FE',
    borderColor: '#bac3d1',
  },
  {
    name: 'Slack',
    logo: '20260707-slack-logo.png',
    color: '#F5EEF6',
    borderColor: '#ad72b7',
  },
];

const IntegrationButtons = ({ onSelect, aiOnly, className = '' }) => {
  return (
    <div className={`integrations-buttons ${className}`}>
      {integrations
        .filter((item) => (aiOnly ? item.name !== 'Slack' : integrationsCondition || item.name === 'Slack'))
        .map(({ name, logo }) => (
          <button
            key={name}
            className='text-left general-button border py-2 specific-x-padding-10 hovered-button flex-centered'
            onClick={() => onSelect(normalize(name))}
          >
            <img
              src={`${import.meta.env.VITE_APP_CDNURL}/images/${logo}`}
              alt={name}
              style={{ width: 'auto', height: '40px', borderRadius: '10px' }}
            />
            <span className='text-left specific-left-padding-10'>Integrate with {name}</span>
          </button>
        ))}
    </div>
  );
};

export default IntegrationButtons;
